import { useState } from "react";
import { toast } from "sonner";
import { Plus, Trash2 } from "lucide-react";
import { api } from "../lib/api";

export const AdminSizeEditor = ({ item, onSaved }) => {
    const [sizes, setSizes] = useState((item.sizes || []).map((s) => ({ ...s })));
    const [price, setPrice] = useState(item.price);
    const [saving, setSaving] = useState(false);

    const update = (i, key, val) => setSizes((arr) => arr.map((s, idx) => (idx === i ? { ...s, [key]: key === "price" ? parseFloat(val || 0) : val } : s)));

    const save = async () => {
        setSaving(true);
        try {
            const body = item.is_original
                ? { price: parseFloat(price || 0) }
                : { sizes: sizes.filter((s) => s.label.trim()).map((s) => ({ label: s.label.trim(), price: s.price || 0 })) };
            await api.patch(`/admin/prints/${item.id}`, body);
            toast.success("Prices saved");
            onSaved();
        } catch (e) {
            toast.error(e?.response?.data?.detail || "Save failed");
        } finally { setSaving(false); }
    };

    return (
        <div className="w-full mt-4 pt-4 border-t border-black/[0.08]" data-testid={`admin-size-editor-${item.id}`}>
            {item.is_original ? (
                <label className="flex items-center gap-3 text-sm">
                    <span className="label-caps">Price A$</span>
                    <input type="number" min="0" value={price} onChange={(e) => setPrice(e.target.value)} className="underline-input w-32" data-testid={`admin-edit-price-${item.id}`} />
                </label>
            ) : (
                <div className="space-y-2">
                    <div className="label-caps text-[#8A8A8A]">Set price to 0 to show the size as “on request”</div>
                    {sizes.map((s, i) => (
                        <div key={i} className="flex items-center gap-3">
                            <input value={s.label} onChange={(e) => update(i, "label", e.target.value)} className="underline-input w-24" data-testid={`admin-edit-size-label-${item.id}-${i}`} />
                            <span className="label-caps">A$</span>
                            <input type="number" min="0" value={s.price} onChange={(e) => update(i, "price", e.target.value)} className="underline-input w-28" data-testid={`admin-edit-size-price-${item.id}-${i}`} />
                            <button type="button" onClick={() => setSizes((arr) => arr.filter((_, idx) => idx !== i))} className="text-[#8A8A8A] hover:text-[#8C3A3A] p-1" data-testid={`admin-edit-size-remove-${item.id}-${i}`}>
                                <Trash2 className="w-3 h-3" />
                            </button>
                        </div>
                    ))}
                    <button type="button" onClick={() => setSizes((arr) => [...arr, { label: "", price: 0 }])} className="inline-flex items-center gap-2 label-caps text-[#1A1A1A] hover:text-[#8C3A3A]" data-testid={`admin-edit-size-add-${item.id}`}>
                        <Plus className="w-3 h-3" /> Add size
                    </button>
                </div>
            )}
            <button onClick={save} disabled={saving} className="mt-4 bg-[#1A1A1A] text-[#FAFAF7] px-6 py-2 rounded-full text-xs tracking-wide hover:bg-[#8C3A3A] transition-colors disabled:opacity-50" data-testid={`admin-edit-save-${item.id}`}>
                {saving ? "Saving..." : "Save prices"}
            </button>
        </div>
    );
};
